import CryptoJS from 'crypto-js'

const SECRET_KEY = CryptoJS.enc.Utf8.parse('DhOfficialSite16')

export function encrypt(text) {
  const srcs = CryptoJS.enc.Utf8.parse(text)
  const encrypted = CryptoJS.AES.encrypt(srcs, SECRET_KEY, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
  return encodeURIComponent(encrypted.toString())
}

export function decrypt(ciphertext) {
  try {
    const decoded = decodeURIComponent(ciphertext)
    const bytes = CryptoJS.AES.decrypt(decoded, SECRET_KEY, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
    return bytes.toString(CryptoJS.enc.Utf8)
  } catch (e) {
    return false
  }
}
